import { render, staticRenderFns } from "./yuzdeinput.vue?vue&type=template&id=fae311be&scoped=true"
import script from "./yuzdeinput.vue?vue&type=script&lang=js"
export * from "./yuzdeinput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae311be",
  null
  
)

export default component.exports